import React from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'

//Components
import { TreeExpandClosedIcon, TreeExpandOpenedIcon} from 'components/SASIcon'

//Styles
import styles from './Item.module.scss'

//Util
import {scrollIntoView} from 'util/tree'

export interface Props {
  label: string,
  level: number,
  index: number,
  count: number,
  item: React.ReactNode,
  expanded?: boolean,
  selected: boolean,
  children?: React.ReactNode[]
  childIsSelected: boolean,
  clickHandler: (e: React.MouseEvent) => void,
  handleKeyDown: (e:React.KeyboardEvent) => void
}

const TreeItem = ({
  level,
  label,
  index,
  count,
  item,
  children,
  expanded,
  selected,
  childIsSelected,
  clickHandler,
  handleKeyDown
}: Props) => {

  if (selected) { scrollIntoView() }

  const hasChildren = children !== undefined
  const { t } = useTranslation()

  const handleKeyboard =(e: React.KeyboardEvent): void => {
    if (e.ctrlKey &&  (e.keyCode === 189 || e.keyCode === 187)) return //enable ctrl + and ctrl - for zoom
    if (e.keyCode !== 9) { //ignore tab key presses so that tab navigation does not get stuck
      e.preventDefault()
      handleKeyDown(e)
    }
  }

  let opts: any = {}
  if (hasChildren) opts['aria-expanded'] = expanded

  return (
    <li className={styles.treeitem}>
      <div 
        {...opts} 
        aria-selected={selected}
        className={`${styles.item} ${selected && styles.item_selected} ${selected ? 'selectedNode': ''} ${(selected || childIsSelected) && styles.selectedText} visibleNode`} 
        tabIndex={selected ? 0 : -1} 
        onClick={clickHandler} 
        onKeyDown={handleKeyboard} 
        aria-label={label+' '+ t('helpcenter-gui-icu.toc.tree.information.aria', {level: level, index: index, count: count})} 
        role={selected ? "tab" : "treeitem"}>
        { hasChildren && expanded && <div className={styles.iconContainer}><TreeExpandOpenedIcon /></div> }
        { hasChildren && !expanded && <div className={styles.iconContainer}><TreeExpandClosedIcon /></div> }
        { item }

      </div>
      { 
        hasChildren && expanded &&
        <ul className={`${styles.children} ${hasChildren && expanded && styles.show}`} >
          { children }
        </ul>
      }
    </li>
  )
}

export default TreeItem